import AnnotationsHandler from '..';
import * as RoutingManager from '../../router/routing-manager';
import { C11nEnv } from '../../interpreter/c11n-env';

AnnotationsHandler.registerHandler('@ROUTING_INFO', (_value: string, c11nEnv: C11nEnv) => {
  return RoutingManager.getRoutingInfo(c11nEnv.getContainerName(), c11nEnv.getContextName());
});
